// Mock data for @techbaenae personal website

export const socialLinks = {
  instagram: "https://instagram.com/techbaenae",
  linkedin: "https://linkedin.com/in/techbaenae",
  email: "mailto:hey@techbaenae.com",
  youtube: "https://www.youtube.com/@techbaenae"
};

export const heroData = {
  brandName: "@techbaenae",
  location: "somewhere data dreaming",
  tagline: "half human. half robot. 100% future focused ✨",
  naomi: {
    title: "IRL",
    name: "Naomi",
    image: "https://customer-assets.emergentagent.com/job_e02576fc-3e7a-4446-bc21-d558624baf1e/artifacts/zhpzfvij_naomi%20headshot%20zoomed%20in.jpg",
    callouts: [
      { text: "loves strawberries", emoji: "🍓" },
      { text: "dog mom to Berry", emoji: "🐶" },
      { text: "data dreamer", emoji: "☁️" },
      { text: "creative strategist", emoji: "✨" }
    ]
  },
  naeI: {
    title: "URL",
    name: "NAE-I",
    image: "https://customer-assets.emergentagent.com/job_fd093b78-2139-4f54-81a1-ff9540d513da/artifacts/utmvpr3r_ChatGPT%20Image%20Dec%2030%2C%202025%2C%2008_51_25%20PM%20%281%29%202.PNG",
    callouts: [
      { text: "NAE-I", emoji: "🦾" },
      { text: "just glitching", emoji: "⚡️" },
      { text: "downloads", emoji: "📡" },
      { text: "byte me", emoji: "🛒" }
    ]
  }
};

export const aboutData = {
  intro: "I'm a creator who thinks about product innovation",
  intro2: "enhancing IRL + URL experiences.",
  phygital: "phygital strategy is the language I use to connect the physical & digital worlds 📈💭",
  naeI: "NAE-I is a robot counterpart I created as an extension of my brand, using visuals + systems thinking to explore how technology shows up in everyday life 🦾",
  cta: "if you're a data dreamer like me, would love to connect!"
};

export const bytemeData = {
  title: "byteme",
  subtitle: "merch by NAE-I",
  tagline: "wear the future",
  comingSoon: true
};

export const credibilityData = {
  title: "previously",
  items: [
    {
      name: "Infinity.Careers",
      description: "founder, acquired in 2023",
      logo: "https://customer-assets.emergentagent.com/job_e02576fc-3e7a-4446-bc21-d558624baf1e/artifacts/z8ji3v5q_infinity_careers_logo_white.png"
    },
    {
      name: "Ford Models",
      description: "signed MIA + CHI markets",
      logo: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/e04idcsb_ford%20images.png"
    },
    {
      name: "Boss Business Market",
      description: "led 30+ creative team",
      logo: "https://customer-assets.emergentagent.com/job_e02576fc-3e7a-4446-bc21-d558624baf1e/artifacts/0h4nfv45_Submark2-white.png"
    }
  ]
};

export const signatureData = {
  statement: "I make it rain in the brainstorm",
  subtext: "Creative phygital strategy that turns ideas into value."
};

export const workCategories = [
  {
    id: 1,
    name: "fashion",
    tagline: "concepts → systems → impact",
    color: "#E8D5E4",
    icon: "fashion"
  },
  {
    id: 2,
    name: "film",
    tagline: "ideas turned into experiences",
    color: "#D5E8E8",
    icon: "film"
  },
  {
    id: 3,
    name: "music",
    tagline: "sound meets strategy",
    color: "#E8E5D5",
    icon: "music"
  },
  {
    id: 4,
    name: "media",
    tagline: "stories that resonate",
    color: "#D5D8E8",
    icon: "media"
  },
  {
    id: 5,
    name: "travel",
    tagline: "explore the world",
    color: "#D5E8D5",
    icon: "travel"
  },
  {
    id: 6,
    name: "wellness",
    tagline: "mind body spirit",
    color: "#E8D5D5",
    icon: "wellness"
  }
];

export const impactData = {
  title: "moments",
  images: [
    { id: 1, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/dubs01in_IMG_5416%20%281%29.jpg" },
    { id: 2, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/xsb5t8ew_naeiteeth.jpeg" },
    { id: 3, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/98xnm9nn_IMG_0253%20%281%29.jpg" },
    { id: 4, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/v6vb2w6n_IMG_2850%202%20%282%29.png" },
    { id: 5, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/yvazfgrq_IMG_0040%20%281%29.jpg" },
    { id: 6, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/p2hajb7s_naeiearimage.jpeg" },
    { id: 7, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/kden3os0_GSV%20Cup%202022%20Naomi%20Thomas%20%281%29.jpg" },
    { id: 8, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/56myszn7_D133483B-8A8A-402B-AC76-F40BB9F1F960%20%281%29.jpg" },
    { id: 9, image: "https://customer-assets.emergentagent.com/job_naenao-duality/artifacts/rdatytrn_IMG_9758%20%281%29.jpg" }
  ]
};

export const communityData = {
  text: "if you're a data dreamer like me, let's become our best selves together",
  buttonText: "get access to resources & 2026 events"
};
